export const phoneNumberFormat = {
  by: {
    countryFormat: /^(\+)?((?:375)(?:25|29|33|44)\d{7})$/,
    errorMessage: "Invalid number format. Valid format: +375 00 000 00 00",
    placeholder: "+375 00 000 00 00",
  },
  cy: {
    countryFormat: /^(\+)?\d+$/,
    errorMessage: "Invalid phone number format",
    placeholder: "Enter phone number",
  },
  lt: {
    countryFormat: /^(\+)?\d+$/,
    errorMessage: "Invalid phone number format",
    placeholder: "Enter phone number",
  },
};

export default (countryCode: "by" | "cy" | "lt") =>
  (inputVal: number | string): null | string => {
    const val = inputVal.toString();

    if (
      val.length > 0 &&
      !phoneNumberFormat[countryCode].countryFormat.test(val)
    ) {
      return phoneNumberFormat[countryCode].errorMessage;
    }

    return null;
  };
